<!-- 翻车机报警记录 -->
<template>
  <div class="wagon-alarm-page">
    <div class="alarm-summary" style="display:flex;align-items:stretch;gap:8px;margin-bottom:8px;overflow-x:auto;">
      <div
        v-for="item in summaryItems"
        :key="item.key"
        class="summary-item"
        style="flex:1 0 120px;min-height:56px;padding:8px 12px;border:1px solid #ebeef5;border-radius:4px;background:#fff;box-sizing:border-box;"
      >
        <div class="summary-label" style="line-height:20px;font-size:12px;color:#606266;">{{ item.label }}</div>
        <div class="summary-value" style="line-height:24px;font-size:18px;font-weight:600;color:#303133;word-break:break-all;">{{ item.value }}</div>
      </div>
    </div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @selection-change="selectionChange"
      @on-load="onLoad"
      @before-open="beforeOpen"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          plain
          icon="el-icon-finished"
          :disabled="selectionList.length === 0"
          @click="handleBatchAlarm"
        >批量处理</el-button>
        <el-button
          type="success"
          size="small"
          plain
          icon="el-icon-circle-check"
          @click="handleOneClickAlarm"
        >一键处理</el-button>
        <el-button
          type="default"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >导出</el-button>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-edit" @click="handleDeviceAlarm(row)">
          处理
        </el-button>
      </template>
    </avue-crud>
    <dialog-reset slotShow height="40vh" top="20vh" width="50%" title="报警处理" :visible.sync="alarmHandVisible">
      <AlarmHandling v-if="alarmHandVisible" :transmitData="transmitData" @handleClose="handleClose"></AlarmHandling>
    </dialog-reset>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, getDetail, getOverview, exportExcel } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";
import { dateFormat } from "@/util/date";
import { downloadXls } from "@/util/util";
import AlarmHandling from "./components/alarm-handling.vue";

export default {
  name: "wagontippler-alarm-record",
  mixins: [crudMixins],
  components: { AlarmHandling },
  data() {
    return {
      apiConfig: { getList, getDetail },
      alarmHandVisible: false,
      transmitData: {},
      exportLoading: false,
      overview: {},
      option: {
        ...this.$store.state.publicOption,
        menu: true,
        selection: true,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: true,
        viewBtnText: '跟踪',
        viewTitle: "跟踪",
        dialogWidth: "1200px",
        dialogHeight: "900px",
        column: [
          {
            label: "设备名称",
            prop: "deviceName",
            width: 160,
            search: true,
            overHidden: true,
            type: "input",
            searchPlaceholder: "请输入设备名称",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          {
            label: "设备类型",
            prop: "deviceType",
            hide: true,
            viewDisplay: true,
            search: true,
            width: 120,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=base_device_type",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
          },
          {
            label: "异常类型",
            prop: "abnormalType",
            search: true,
            width: 110,
            type: "select",
            dicData: [
              { label: "超时", value: "超时" },
              { label: "中断", value: "中断" },
              { label: "顺序错误", value: "顺序错误" },
            ],
            props: {
              label: "label",
              value: "value",
            },
            dataType: "string",
          },
          {
            label: "报警等级",
            prop: "alarmLevel",
            search: true,
            width: 110,
            type: "select",
            dicData: [
              { label: "预警", value: "1" },
              { label: "一般", value: "2" },
              { label: "紧急", value: "3" },
            ],
            props: {
              label: "label",
              value: "value",
            },
            dataType: "string",
          },
          {
            label: "报警状态",
            prop: "alertStatus",
            type: 'select',
            overHidden: true,
            search: true,
            width: 110,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=alert_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          {
            label: '报警时间',
            prop: 'alertTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '当前数值',
            prop: 'currentValue',
            hide: true,
            viewDisplay: true,
            type: 'number',
            precision: 8,
          },
          {
            label: '阈值数值',
            prop: 'thresholdValue',
            hide: true,
            viewDisplay: true,
            type: 'number',
            precision: 8,
          },
          {
            label: '报警内容',
            prop: 'alarmContent',
            type: "textarea",
            span: 24,
            minRows: 3,
            search: false,
            overHidden: true,
            minWidth: 240,
          },
          {
            label: '处理时间',
            prop: 'processTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '处理结果',
            prop: 'processResult',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false,
          },
          {
            label: "处理人",
            prop: "processorName",
            align: "center",
            width: 100,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            search: true,
          },
        ]
      },
    }
  },
  computed: {
    summaryItems() {
      return [
        { key: "today", label: "今日异常", value: this.formatCount(this.overview.todayCount) },
        { key: "warning", label: "预警", value: this.formatCount(this.overview.warningCount) },
        { key: "unhandled", label: "未处理", value: this.formatCount(this.overview.unhandledCount) },
        { key: "handled", label: "已处理", value: this.formatCount(this.overview.handledCount) },
        { key: "latest", label: "最新报警", value: this.formatLatestAlertTime(this.overview.latestAlertTime) },
      ]
    }
  },
  methods: {
    initCardData() {
      this.loadOverview()
    },
    buildAlarmHandlingQuery() {
      return this.formatParams(Object.assign({}, this.defaultParams, this.query))
    },
    loadOverview() {
      const params = this.queryData || this.buildAlarmHandlingQuery()
      getOverview(params).then(({ data }) => {
        this.overview = data.data || {}
      }).catch(() => {
        this.overview = {}
      })
    },
    formatCount(value) {
      return value === null || value === undefined || value === "" ? 0 : value
    },
    formatLatestAlertTime(value) {
      if (value === null || value === undefined || value === "") {
        return "-"
      }
      if (typeof value === "number") {
        return this.formatDateValue(value)
      }
      if (typeof value === "string") {
        const text = value.trim()
        if (!text) {
          return "-"
        }
        if (/^\d+$/.test(text)) {
          return this.formatDateValue(Number(text))
        }
        const normalized = text.replace("T", " ").replace(/\.\d+Z?$/, "").replace(/Z$/, "")
        const date = new Date(text)
        if (!isNaN(date.getTime())) {
          return dateFormat(date)
        }
        return normalized.length > 19 ? normalized.slice(0, 19) : normalized
      }
      if (value instanceof Date) {
        return this.formatDateValue(value.getTime())
      }
      if (typeof value === "object") {
        const timeValue = value.time || value.timestamp || value.value || value.dateTime || value.latestAlertTime
        if (timeValue !== null && timeValue !== undefined && timeValue !== "") {
          return this.formatLatestAlertTime(timeValue)
        }
        if (value.year !== undefined && value.month !== undefined && value.date !== undefined) {
          const date = new Date(
            Number(value.year) + 1900,
            Number(value.month),
            Number(value.date),
            Number(value.hours || 0),
            Number(value.minutes || 0),
            Number(value.seconds || 0)
          )
          return isNaN(date.getTime()) ? "-" : dateFormat(date)
        }
      }
      return "-"
    },
    formatDateValue(value) {
      const timestamp = String(value).length === 10 ? Number(value) * 1000 : Number(value)
      const date = new Date(timestamp)
      return isNaN(date.getTime()) ? "-" : dateFormat(date)
    },
    handleBatchAlarm() {
      if (!this.selectionList || this.selectionList.length === 0) {
        this.$message.warning('请选择需要处理的报警记录')
        return
      }
      this.transmitData = {
        type: 'batch',
        ids: this.ids
      }
      this.alarmHandVisible = true
    },
    handleOneClickAlarm() {
      const query = this.buildAlarmHandlingQuery()
      this.$confirm('确认按当前查询条件一键处理全部翻车机报警记录？', '提示', { type: 'warning' }).then(() => {
        this.transmitData = {
          type: 'oneClick',
          query
        }
        this.alarmHandVisible = true
      }).catch(() => {})
    },
    async handleExport() {
      this.exportLoading = true
      try {
        const params = this.buildAlarmHandlingQuery()
        const res = await exportExcel(params)
        downloadXls(res.data, `翻车机报警记录_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    handleDeviceAlarm(row) {
      this.transmitData = { type: 'add', id: row.id || null }
      this.alarmHandVisible = true
    },
    handleClose() {
      this.alarmHandVisible = false
      this.onLoad(this.page, this.query)
      this.loadOverview()
    },
  }
}
</script>

<style scoped lang="scss">
.wagon-alarm-page {
  .alarm-summary {
    display: grid;
    grid-template-columns: repeat(5, minmax(120px, 1fr));
    gap: 8px;
    margin-bottom: 8px;
  }

  .summary-item {
    min-height: 56px;
    padding: 8px 12px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fff;
  }

  .summary-label {
    line-height: 20px;
    font-size: 12px;
    color: #606266;
  }

  .summary-value {
    line-height: 24px;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    word-break: break-all;
  }
}

@media (max-width: 1200px) {
  .wagon-alarm-page {
    .alarm-summary {
      grid-template-columns: repeat(3, minmax(120px, 1fr));
    }
  }
}
</style>
